const CardBody = {
  baseStyle: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
}

export const CardBodyComponent = {
  ...CardBody,
}
